(() => {
  const newBogosBundleHome = document.querySelector(".js-bogos-bundle-holder");

  function moveBogosBundle() {
    const bogosBundle = document.querySelector("#bogos-bundle-view");

    if (bogosBundle && newBogosBundleHome) {
      newBogosBundleHome.append(bogosBundle);
    }
  }

  function waitForElms(selectors) {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(selectors) || selectors.length === 0) {
        return reject(new Error("Invalid selectors array."));
      }

      const elementsExist = () => selectors.every((sel) => document.querySelector(sel));

      if (elementsExist()) {
        return resolve();
      }

      let found = false;
      const observer = new MutationObserver(() => {
        if (elementsExist()) {
          found = true;
          observer.disconnect();
          resolve();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      const timeout = setTimeout(() => {
        if (!found) {
          observer.disconnect();
          if (newBogosBundleHome) newBogosBundleHome.classList.add("hidden");
          reject(new Error("Elements not found within timeout."));
        }
      }, 3000);

      // Clear the timeout if promise resolves early
      const clearResources = () => {
        clearTimeout(timeout);
        observer.disconnect();
      };

      // Ensure timeout is cleared if elements are found
      return resolve().finally(clearResources);
    });
  }

  waitForElms([
    "#bogos-bundle-view",
    ".bogos-bundles-widget",
    ".bogos-bundles-widget-header",
    ".bogos-bundles-widget-body",
    ".bogos-bundles-widget-footer",
  ])
    .then(moveBogosBundle)
    .catch((error) => console.error("Error loading elements:", error));
})();
